<form name="RoleForm" (ngSubmit)="RoleForm.form.valid && SaveRole()" #RoleForm="ngForm">
    <div class="card">
        <div class="card-header">
            <div class="card-title">Role</div>
        </div>

        <div class="m-2 card-body">
            <div class="row">
                <div class="col-md-12 px-1">
                    <label>Role Name</label>
                    <input name="RoleName" maxlength="100" class="form-control" placeholder="Ex. Coordinator"
                        [(ngModel)]="RoleDetail.RoleName" #RoleName="ngModel" required>
                    <!-- <div *ngIf="RoleName.hasError('required')" style="color: red;">
                        Please enter role name.
                    </div> -->
                    <div class="invalid-feedback">
                        Please enter role name.
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 px-1">
                    <label>Users</label>
                    <ng-select [items]="UsersFilter" [multiple]="true" bindLabel="UserName" name="muliex"
                        [selectableGroup]="false" [selectableGroupAsModel]="false" [closeOnSelect]="false"
                        bindValue="UserMasterId" [(ngModel)]="RoleDetail.UserMasterIdObj" required>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.UserName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.UserName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} +...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select user.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary me-1" (click)="close()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>

                        <button *ngIf="(this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)" type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Save':'Loading...'}}</button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</form>